import {Component, OnInit} from '@angular/core';
import {PageGlobalParameters} from '@models/pages/page-global-parameters';
import {MenuItem} from '@models/sidebar/menu-item';
import {ActivatedRoute} from '@angular/router';
import {PagesHelperService} from '@services/pages/pages-helper.service';
import {BreadcrumbService} from '@services/breadcrumb/breadcrumb.service';
import {BucketBrowserPage} from '@models/sidebar/response/bucket-browser-page';
import {BucketBrowserFile} from '@models/pages/bucket-browser/bucket-browser-file';
import {DashboardLayouts} from '@models/dashboard/dashboard-layouts';

@Component({
    selector: 'scitis-bucket-browser-container',
    templateUrl: './bucket-browser-container.component.html',
    styleUrls: ['./bucket-browser-container.component.scss'],
    standalone: false
})
export class BucketBrowserContainerComponent implements OnInit {

  public pageGlobalParameters: PageGlobalParameters = new PageGlobalParameters();
  public routes: MenuItem[] = [];
  public layout: DashboardLayouts = DashboardLayouts.TILE;
  public bucketBrowserPageDetails: BucketBrowserPage | undefined = undefined;
  public searchItems: BucketBrowserFile[] = [];
  public selectedItem: BucketBrowserFile | undefined = undefined;
  public searchResultItems: BucketBrowserFile[] = [];
  public closeSearchTimestamp: number = 0;
  public hideCloseSearchButtonTimestamp: number = 0;

  constructor(private activatedRoute: ActivatedRoute,
              private pagesHelperService: PagesHelperService,
              private breadcrumbService: BreadcrumbService) {
  }

  ngOnInit(): void {
    this.pageGlobalParameters = this.pagesHelperService.getPageDetailsFromUrl(this.activatedRoute.snapshot.paramMap);
    this.generateRoutes(this.pageGlobalParameters.associatedMenuItem);
  }

  setBucketBrowserPageDetails(bucketBrowserPageDetails: BucketBrowserPage): void {
    this.bucketBrowserPageDetails = bucketBrowserPageDetails;
  }

  setSearchItems(searchItems: BucketBrowserFile[]): void {
    this.searchItems = searchItems;
  }

  setLayout(layout: DashboardLayouts): void {
    this.layout = layout;
  }

  onSelectedItem(selectedItem: BucketBrowserFile): void {
    this.selectedItem = selectedItem;
  }

  onSearchResultItems(searchResultItems: BucketBrowserFile[]): void {
    this.searchResultItems = searchResultItems;
  }

  onCloseSearch(): void {
    this.closeSearchTimestamp = new Date().getTime();
  }

  onFolderOpened(): void {
    this.closeSearchTimestamp = new Date().getTime();
  }

  onHideCloseSearchButton(): void {
    this.hideCloseSearchButtonTimestamp = new Date().getTime();
  }

  private generateRoutes(menuItem: MenuItem) {
    this.routes = this.breadcrumbService.generateRoutes(menuItem);
  }

}

